exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\na, .btn, .pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.text-white-less {\r\n\tcolor: rgb(210, 210, 210);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/INMOGR/Desktop/Angular Project/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Users/INMOGR/Desktop/Angular Project/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles